type ScaleLinearFunction = (value: number) => number;

interface ScaleLinear extends ScaleLinearFunction {
  domain: (values: [number, number]) => ScaleLinear;
  range: (values: [number, number]) => ScaleLinear;
}

/**
 * 创建一个线性缩放函数，用于将给定的值在指定的域和范围之间进行线性映射。
 * @returns 线性缩放函数
 */
export function scaleLinear(): ScaleLinear {
  let _minValue: number;
  let _maxValue: number;
  let _max: number;
  let _min: number;

  /**
   * 执行线性缩放的函数，接受一个值，并将其映射到指定的范围内。
   * @param value 要进行缩放的值
   * @returns 缩放后的值
   */
  const getResult: ScaleLinear = (value) => {
    if (_maxValue === _minValue) {
      return _min;
    }
    return ((value - _minValue) / (_maxValue - _minValue)) * (_max - _min) + _min;
  };

  /**
   * 设置线性缩放函数的域。
   * @param values 域的最小值和最大值 [minValue, maxValue]
   * @returns 当前的线性缩放函数
   */
  getResult.domain = function ([minValue, maxValue]: [number, number]): ScaleLinear {
    _minValue = minValue;
    _maxValue = maxValue;
    return getResult;
  };

  /**
   * 设置线性缩放函数的范围。
   * @param values 范围的最小值和最大值 [min, max]
   * @returns 当前的线性缩放函数
   */
  getResult.range = function ([min, max]: [number, number]): ScaleLinear {
    _min = min;
    _max = max;
    return getResult;
  };

  return getResult;
}
